import React, { cloneElement, FC, Suspense, useEffect } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { store } from './store/configure-store';
import { appMount } from './store/reducers/app-reducer';
import history from './navigation/history';
import NoMatch from './screens/NoMatch';
import Loader from './components/Loader';
import { routesList } from './navigation';

const App: FC = () => {
    useEffect(() => {
        store.dispatch(appMount());
    }, []);

    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Switch>
                    <Suspense fallback={<Loader fullScreen />}>
                        {routesList.map((route, i) => cloneElement(route, { key: i }))}
                    </Suspense>

                    <Route component={NoMatch} />
                </Switch>
            </ConnectedRouter>
            <ToastContainer />
        </Provider>
    );
};

export default App;
